import { Avatar, Button, Col, Dropdown, Icon, Layout, Menu, Row } from 'antd';
import React, { Component, FunctionComponent } from 'react';
import { Link } from 'react-router-dom';

import { config } from '../../config';
import { authManager } from '../../services/auth';
import { noMaskingManager } from '../../services/noMasking';
import { userManager } from '../../services/user';
import { CrmSideMenu } from './CrmSideMenu';

const { Header, Content, Footer } = Layout;

function logout() {
  authManager.invalidate();
  userManager.clearUser();
  noMaskingManager.clearNoMasking();
}
interface Props extends FunctionComponent {
  pathname: string;
}
interface State {
  collapsed: boolean;
}
export class CrmLayout extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      collapsed: false,
    };
  }

  toggle = () => {
    this.setState({ collapsed: !this.state.collapsed });
  };

  render() {
    const user = userManager.getUser();
    const { children, pathname } = this.props;
    const userMenu = (
      <Menu>
        <Menu.Item>
          <Link to="/auth">
            {user ? (
              <Button type="danger" onClick={() => logout()}>
                <Icon type="logout" theme="outlined" />
                <span>退出</span>
              </Button>
            ) : (
              <Button onClick={() => logout()}>
                <Icon type="login" theme="outlined" />
                <span>登录</span>
              </Button>
            )}
          </Link>
        </Menu.Item>
      </Menu>
    );
    return (
      <Layout style={{ height: '100vh' }}>
        <CrmSideMenu collapsed={this.state.collapsed} pathname={pathname} />
        <Layout>
          <Header
            style={{
              background: '#fff',
              padding: '0 25px',
              boxShadow: '0 1px 4px rgba(0, 21, 41, 0.08)',
            }}
          >
            <Row type="flex" justify="space-between">
              <Col>
                <Icon
                  style={{ fontSize: 20 }}
                  className="trigger"
                  type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
                  onClick={this.toggle}
                />
              </Col>
              <Col>
                <Avatar shape="square" size={38} style={{ marginRight: '10px' }} src={user && user.avatarUrl} />
                <Dropdown overlay={userMenu}>
                  <a className="ant-dropdown-link">
                    {user && user.name ? user.name : '未登录'}
                    <Icon type="down" />
                  </a>
                </Dropdown>
              </Col>
            </Row>
          </Header>

          <Content style={{ padding: '20px', minHeight: 'auto', overflowX: 'auto' }}>{children}</Content>

          <Footer style={{ textAlign: 'center' }}>©2018 聪明派 版本号:{config.VERSION}</Footer>
        </Layout>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/layouts/CrmLayout.tsx